module.exports = __webpack_public_path__ + "img/close-big.c50c9526.svg";